import { render, staticRenderFns } from "./onebox-alloutboxsystem-new.vue?vue&type=template&id=d5bfc5b4&scoped=true&"
import script from "./onebox-alloutboxsystem-new.vue?vue&type=script&lang=js&"
export * from "./onebox-alloutboxsystem-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-alloutboxsystem-new.vue?vue&type=style&index=0&id=d5bfc5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bfc5b4",
  null
  
)

export default component.exports